export const euCountries = [
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IE",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
];

export const usCountries = ["US", "CA"];

export const currencyToCountry = {
  gbp: "GB",
  aud: "AU",
  eur: "EU",
  usd: "US",
};

export const countryToCurrency = {
  GB: "gbp",
  AU: "aud",
  EU: "eur",
  US: "usd",
};
